import { DgtPdOrderPicklistMovement } from "../models"
import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineClose } from 'react-icons/ai'
import { SummaryRow } from '../constants/Column'
import { IoMdAddCircle } from "react-icons/io"

const RemoveUnusedMvEditor = memo(({ props } : {
  props: EditorProps<DgtPdOrderPicklistMovement, SummaryRow>
}) => {
  const { onClose, onRowChange, row } = props

  const isReOpen = row.canceledDateTime! > 0

  return <Modal show={true} onHide={onClose}
    okTheme={isReOpen ? 'success' : 'danger'}
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { ...row }
      updatedRow.canceledDateTime = isReOpen ? 0 : Math.floor(Date.now() / 1000)
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={isReOpen ? 'เปิดมาใหม่' : 'คำเตือนเนื่องจากมีการลบรายการจ่ายที่ไม่ใช้แล้ว'}
    maxWidth='max-w-lg'
    >
    <div className='flex items-center gap-3'>
      {isReOpen ? <IoMdAddCircle size={22} className='text-green-700 ' /> 
      : <AiOutlineClose size={50} className='text-red-500 basis-1/6 ' />}
      <div className="space-y-3 ">
        <h6>{isReOpen ? 'คุณกำลังจะเปิดรายการกลับมาใหม่' : 'คุณกำลังจะลบรายการจ่ายที่ไม่ใช้แล้ว ดังนี้'}</h6>
        <h6 className={`font-bold${isReOpen ? 'text-green-700' : 'text-red-500'}`}>Batch No : {row.batchLotNo}</h6>
        <h6>ยืนยันหรือไม่ ?</h6>
      </div>
    </div>
  </Modal>
})

export default RemoveUnusedMvEditor